import React from 'react';
import { Link } from 'react-router-dom'; // Change back to react-router-dom
import './LandingFooter.css';
import logo from '../../../image-assets/logo.svg'; // Import the logo

const LandingFooter = () => {
  return (
    <footer className="landing-footer-section">
      <div className="landing-footer-main-content"> {/* Added wrapper */}
        <div className="landing-footer-logo-area"> {/* Logo container */}
          <img src={logo} alt="Texta Logo" className="landing-footer-logo" />
          {/* Optional: Add a tagline or short text below the logo */}
        </div>
        <div className="landing-footer-links-area"> {/* Links container */}
          <div className="landing-footer-column">
            <h5 className="landing-footer-column-title">Product</h5>
            <Link to="/features" className="landing-footer-link">Features</Link> {/* Back to Link */}
            <Link to="/pricing" className="landing-footer-link">Pricing</Link> {/* Back to Link */}
            <Link to="/docs" className="landing-footer-link">Documentation</Link> {/* Added Docs Link */}
            {/* Add more product links as needed */}
          </div>
          <div className="landing-footer-column">
            <h5 className="landing-footer-column-title">Company</h5>
            <Link to="/about" className="landing-footer-link">About Us</Link> {/* Add About Us link back */}
            <a href="https://www.linkedin.com/company/texta-localisation" target="_blank" rel="noopener noreferrer" className="landing-footer-link">LinkedIn</a>
            <a href="https://x.com/texta_app" target="_blank" rel="noopener noreferrer" className="landing-footer-link">X (Twitter)</a>
          </div>
          <div className="landing-footer-column">
            <h5 className="landing-footer-column-title">Legal</h5>
            {/* Remove reloadDocument as it's now handled by react-router-dom */}
            <Link to="/terms-conditions" className="landing-footer-link">
              Terms & Conditions
            </Link>
            <Link to="/cookie-policy" className="landing-footer-link">Cookie Policy</Link>
          </div>
          {/* Add more columns as needed */}
        </div>
      </div>
      <div className="landing-footer-bottom">
        <p>&copy; {new Date().getFullYear()} Texta. All rights reserved.</p>
        {/* Add social media links or other bottom info here */}
      </div>
    </footer>
  );
};

export default LandingFooter; 